export default "__VITE_ASSET__DqdtVdO5__"